import React from 'react';
import { Flex } from '@withjoy/joykit';

import { loadable } from '@shared/core/loadableFromNamedExport';
import { GuestBookingTileSkeletonList } from '../GuestBookingTile';

export const LazyBookingsTabLegacy = loadable(() => import(/* webpackChunkName: "admin/accommodations/BookingsTabLegacy" */ './BookingsTabLegacy'), 'BookingsTabLegacy', {
  fallback: (
    <Flex
      gap={5}
      paddingTop={4}
      flexDirection="column"
      paddingX={{ _: 6, sm2: 8 }}
    >
      <GuestBookingTileSkeletonList />
    </Flex>
  ),
});
